export enum channelPartnerInvestmentStages {
  EOI = 'EOI',
  PAS4 = 'PAS4',
  FullPay = 'FullPay',
  Registration = 'RegistrationComplete',
}
